import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { M } from '@dashboard-experience/mastodon';
import { i18n } from '@international/mastodon-i18n';
import { Upload } from 'components/fields';
import { required1Document } from 'lib/validations';
import 'scss/MvrMatrixDocumentUpload.scss';
import MvrMatrixDocumentUploadDetail from './MvrMatrixDocumentUploadDetail';
import { t } from '../../../lib/i18n/t';

class MvrMatrixDocumentUpload extends React.Component {
  renderDownload = () => {
    const { matrixField, consentFormUriOverride } = this.props;
    // Only show download when the source field config had a consent form URI;
    // then use override if provided, else the API value.
    if (!matrixField?.consentFormUri) return null;
    const consentFormUri = consentFormUriOverride ?? matrixField.consentFormUri;

    return (
      <M.GridRow className='form-content v1-success-block'>
        <M.Button
          kind='secondary'
          href={consentFormUri}
          target='_blank'
          rel='noopener noreferrer'
        >
          <M.Icon icon='Download' size={16} />
          &nbsp;{i18n.getStr('buttons.downloadPDF')}
        </M.Button>
      </M.GridRow>
    );
  };

  renderUploadedDocuments = () => {
    const { matrixField, formValue, removeFile } = this.props;
    const fieldType = matrixField.type;

    if (formValue && formValue[fieldType] && formValue[fieldType].length > 0) {
      return (
        <>
          {formValue[fieldType].map((doc, index) => (
            <M.Container.Col
              lg={16}
              key={doc.uploadId}
              className='v1-success-block container-col'
            >
              <div>
                <M.Icon icon='CheckmarkFilled' size={16} />{' '}
              </div>
              <span>
                <strong>{doc.filename}</strong>
              </span>
              <M.Button kind='tertiary' onClick={() => removeFile(index)}>
                {t('buttons.remove')}
              </M.Button>
            </M.Container.Col>
          ))}
        </>
      );
    }

    return null;
  };

  renderDocumentUploadButton = () => {
    const { matrixField, options, formValue } = this.props;
    // 10MB file size limit
    const key = matrixField.id || matrixField.name;
    const fieldType = matrixField.type;

    if (
      !formValue ||
      !formValue[fieldType] ||
      formValue[fieldType].length < options.maxFiles
    ) {
      return (
        <Field
          type='upload'
          name={`${key}.${fieldType}`}
          buttonText={i18n.getStr('buttons.upload')}
          component={Upload}
          options={{ maxSize: 10485760, ...options }}
          validate={[required1Document]}
          v1
        />
      );
    }

    return null;
  };

  render() {
    const { matrixField } = this.props;

    return (
      <M.Grid>
        <MvrMatrixDocumentUploadDetail matrixField={matrixField} />
        <M.Container.Row>
          <M.Container.Col className='download-upload-buttons'>
            {this.renderDownload()}
            {this.renderDocumentUploadButton()}
          </M.Container.Col>
          {this.renderUploadedDocuments()}
        </M.Container.Row>
      </M.Grid>
    );
  }
}

MvrMatrixDocumentUpload.propTypes = {
  formValue: PropTypes.object.isRequired,
  matrixField: PropTypes.object.isRequired,
  consentFormUriOverride: PropTypes.string,
  removeFile: PropTypes.func.isRequired,
  options: PropTypes.object,
};

MvrMatrixDocumentUpload.defaultProps = {
  consentFormUriOverride: undefined,
  options: { maxFiles: 1 },
};

export default i18n.renderTranslation()(MvrMatrixDocumentUpload);
